// Deep Arabic translations for catalog content — keyed by stable English source string.
// Used in public pages (Services, Industries, Projects) to surface AR copy when lang === "ar".
// Keep keys stable; values can be updated.

const AR = {
  // ----- Core Services / capabilities -----
  "Water Treatment Solutions": "حلول معالجة المياه",
  "Engineering and procurement support for RO, UF, DAF, clarifier, multimedia filtration, dosing and containerized water treatment systems.":
    "دعم هندسي وشرائي لأنظمة التناضح العكسي والفلترة الدقيقة وأنظمة DAF والمصفّيات والفلترة متعددة الوسائط وأنظمة الجرعات والمحطات الحاوية لمعالجة المياه.",
  "Engineering Support Services": "خدمات الدعم الهندسي",
  "Process, mechanical, electrical and instrumentation engineering — calculations, PFDs, P&IDs, datasheets and layouts.":
    "هندسة العمليات والميكانيكا والكهرباء وأجهزة القياس — الحسابات، PFD، P&ID، بيانات المعدات والتخطيطات.",
  "Procurement & Sourcing": "التوريد والشراء",
  "International sourcing, vendor identification, supplier qualification, expediting and logistics coordination.":
    "توريد دولي، تحديد المورّدين، تأهيل الموردين، التعجيل وتنسيق اللوجستيات.",
  "Vendor & Technology Coordination": "تنسيق المورّدين والتكنولوجيا",
  "Matching project requirements to suitable technologies and qualified international vendors.":
    "مطابقة متطلبات المشروع مع التقنيات المناسبة والمورّدين الدوليين المؤهلين.",
  "Technical Bid Evaluation": "التقييم الفني للعروض",
  "Bidding Support Service": "خدمات دعم المناقصات",
  "Independent technical and commercial evaluation of vendor offers, document review and clarifications.":
    "تقييم فني وتجاري مستقل لعروض الموردين، مراجعة الوثائق والاستيضاحات.",
  "Project Development Consulting": "استشارات تطوير المشاريع",
  "Project Management & Consulting": "إدارة المشاريع والاستشارات",
  "Concept development, feasibility, technology selection and budgetary estimation for industrial and infrastructure projects.":
    "تطوير المفهوم، دراسات الجدوى، اختيار التكنولوجيا والتقدير المبدئي للتكاليف للمشاريع الصناعية والبنية التحتية.",
  "Industrial Systems Integration": "تكامل الأنظمة الصناعية",
  "Coordinating mechanical, electrical and I&C scopes into integrated, deliverable engineered systems.":
    "تنسيق نطاقات الميكانيكا والكهرباء والتحكم وأجهزة القياس في أنظمة هندسية متكاملة قابلة للتسليم.",
  "Commissioning Support": "دعم التشغيل والمناولة",
  "Inspection & Commissioning Support": "دعم التفتيش والتشغيل",
  "FAT / SAT support, pre-commissioning and commissioning assistance through project-specific arrangements.":
    "دعم اختبارات FAT / SAT، أعمال ما قبل التشغيل والمساعدة في التشغيل عبر ترتيبات محددة للمشروع.",
  "Technical Advisory": "الاستشارات الفنية",
  "Independent advisory on engineering scope, procurement strategy and execution planning.":
    "استشارات مستقلة في نطاق الأعمال الهندسية واستراتيجية التوريد وتخطيط التنفيذ.",

  // ----- Industries -----
  "Oil & Gas": "النفط والغاز",
  "Engineering, procurement and technology support for the upstream and midstream oil & gas sector.":
    "دعم هندسي وشرائي وتقني لقطاع النفط والغاز في المرحلتين العليا والمتوسطة.",
  "Power Generation": "توليد الطاقة",
  "Engineering and procurement coordination for power plants and auxiliary utility systems.":
    "تنسيق هندسي وشرائي لمحطات الطاقة وأنظمة الخدمات المساعدة.",
  "Petrochemical": "البتروكيماويات",
  "Engineering and procurement support for process and utility systems in petrochemical facilities.":
    "دعم هندسي وشرائي لأنظمة العمليات والخدمات في منشآت البتروكيماويات.",
  "Water & Wastewater": "المياه ومياه الصرف",
  "Engineering and integration support for industrial, municipal and wastewater treatment plants.":
    "دعم هندسي وتكاملي لمحطات معالجة المياه الصناعية والبلدية ومياه الصرف.",
  "Industrial Facilities": "المنشآت الصناعية",
  "Engineering, procurement and vendor coordination for cement, manufacturing and utility upgrade projects.":
    "هندسة وتوريد وتنسيق مورّدين لمشاريع الإسمنت والتصنيع وترقية الخدمات.",
  "Infrastructure Projects": "مشاريع البنية التحتية",
  "Engineering and procurement support for utility infrastructure, brownfield modifications and production-increase studies.":
    "دعم هندسي وشرائي للبنية التحتية للخدمات، التعديلات على المنشآت القائمة، ودراسات زيادة الإنتاج.",

  // ----- Lifecycle steps -----
  "Concept Development": "تطوير المفهوم",
  "Define project objectives, scope boundaries and high-level technical concept.":
    "تحديد أهداف المشروع وحدود النطاق والمفهوم الفني العام.",
  "Technical Evaluation": "التقييم الفني",
  "Technology benchmarking, process selection and feasibility analysis.":
    "مقارنة التقنيات، اختيار العملية وتحليل الجدوى.",
  "Engineering Support": "الدعم الهندسي",
  "Process, mechanical, electrical and I&C engineering support.":
    "دعم هندسة العمليات والميكانيكا والكهرباء والتحكم.",
  "Procurement Coordination": "تنسيق التوريد",
  "Vendor identification, technical bid evaluation, expediting and inspection coordination.":
    "تحديد المورّدين، التقييم الفني للعروض، التعجيل وتنسيق التفتيش.",
  "Execution Support": "دعم التنفيذ",
  "Construction and installation support through project-specific arrangements.":
    "دعم أعمال البناء والتركيب عبر ترتيبات محددة للمشروع.",
  "Commissioning Assistance": "المساعدة في التشغيل",
  "FAT / SAT, pre-commissioning and commissioning support.":
    "دعم اختبارات FAT / SAT وأعمال ما قبل التشغيل والتشغيل.",

  // ----- Why Choose -----
  "UAE Registered Company": "شركة مسجّلة في الإمارات",
  "Registered under IFZA, Dubai — operating with a clear regional and international remit.":
    "مسجّلة لدى IFZA، دبي — تعمل بصلاحيات إقليمية ودولية واضحة.",
  "Regional Market Knowledge": "معرفة بالأسواق الإقليمية",
  "Working understanding of Iraq, UAE and Egypt project environments and procurement realities.":
    "فهم عملي لبيئات المشاريع في العراق والإمارات ومصر وواقع التوريد.",
  "Engineering & Procurement Experience": "خبرة هندسية وتوريد",
  "Hands-on experience across engineering deliverables and procurement support.":
    "خبرة ميدانية في المخرجات الهندسية ودعم التوريد.",
  "International Supplier Network": "شبكة موردين دولية",
  "Access to a curated network of qualified manufacturers and technology providers.":
    "وصول إلى شبكة منتقاة من المصنّعين المؤهلين وموردي التقنية.",
  "Technical Evaluation Capability": "قدرة على التقييم الفني",
  "Structured technical bid evaluation, datasheet and document review competence.":
    "تقييم منهجي للعروض الفنية، ومراجعة بيانات المعدات والوثائق.",
  "Water Treatment Specialization": "تخصص في معالجة المياه",
  "Focused expertise in industrial, municipal and wastewater treatment technologies.":
    "خبرة مركّزة في تقنيات معالجة المياه الصناعية والبلدية ومياه الصرف.",
  "Vendor Coordination Expertise": "خبرة في تنسيق المورّدين",
  "Bridging clients and suppliers on commercial, technical and logistical fronts.":
    "ربط العملاء بالمورّدين على المستويات التجارية والفنية واللوجستية.",
  "Flexible Project Support Model": "نموذج دعم مرن للمشاريع",
  "Engagement scaled to client need — from advisory through to project-specific execution support.":
    "نطاق ارتباط متدرّج بحسب احتياجات العميل — من الاستشارة إلى دعم التنفيذ.",

  // ----- Service categories titles -----
  "Water Treatment Technology Solutions": "حلول تقنيات معالجة المياه",
  "Procurement & Vendor Coordination": "التوريد وتنسيق المورّدين",
  "Mechanical Equipment Supply Support": "دعم توريد المعدات الميكانيكية",
  "Electrical, Instrumentation & Control": "الكهرباء وأجهزة القياس والتحكم",
  "Project Development & Consultancy": "تطوير المشاريع والاستشارات",

  // ----- Project experience titles -----
  "Water Treatment Plant Engineering Studies": "دراسات هندسية لمحطات معالجة المياه",
  "Concept development, technology selection and engineering studies for industrial and municipal water treatment plants.":
    "تطوير المفهوم، اختيار التكنولوجيا، ودراسات هندسية لمحطات معالجة المياه الصناعية والبلدية.",
  "Industrial Utility System Support": "دعم أنظمة الخدمات الصناعية",
  "Engineering and procurement support for industrial utility systems including filtration, dosing and pumping packages.":
    "دعم هندسي وشرائي لأنظمة الخدمات الصناعية، شاملاً وحدات الفلترة والجرعات والضخ.",
  "Procurement Support for Oil & Gas Facilities": "دعم التوريد لمنشآت النفط والغاز",
  "International sourcing, technical bid evaluation and vendor coordination for mechanical, electrical and I&C scopes.":
    "توريد دولي، تقييم فني للعروض، وتنسيق المورّدين لنطاقات الميكانيكا والكهرباء والتحكم.",
  "Vendor Coordination for Infrastructure Projects": "تنسيق المورّدين لمشاريع البنية التحتية",
  "Vendor identification, supplier qualification and procurement coordination for infrastructure utility scopes.":
    "تحديد المورّدين، تأهيل الموردين وتنسيق التوريد لنطاقات خدمات البنية التحتية.",
  "Technical Evaluation & Technology Selection": "التقييم الفني واختيار التكنولوجيا",
  "Independent technical bid evaluation, technology benchmarking and selection support for industrial process and utility systems.":
    "تقييم فني مستقل للعروض، ومقارنة التقنيات ودعم اختيارها لأنظمة العمليات والخدمات الصناعية.",
  "Commissioning & FAT / SAT Support": "دعم التشغيل واختبارات FAT / SAT",
  "FAT / SAT participation, pre-commissioning and commissioning support through project-specific arrangements.":
    "المشاركة في اختبارات FAT / SAT ودعم ما قبل التشغيل والتشغيل عبر ترتيبات محددة للمشروع.",

  // ----- Industries page bullets -----
  "Custody transfer metering skids": "وحدات قياس نقل الملكية",
  "Oily water separator packages": "حزم فاصل المياه الزيتية",
  "Chemical injection skids": "وحدات حقن المواد الكيميائية",
  "Pump rooms & valve manifolds": "غرف المضخات ومجمعات الصمامات",
  "Ex-rated electrical & I&C equipment": "معدات كهرباء وتحكم معتمدة للمناطق الخطرة",
  "Power transformers & generators": "محوّلات ومولدات الطاقة",
  "LV/MCC panels": "لوحات LV / MCC",
  "PLC/SCADA control systems": "أنظمة تحكم PLC / SCADA",
  "Cooling water filtration upgrades": "ترقيات فلترة مياه التبريد",
  "Process & utility piping": "أنابيب العمليات والخدمات",
  "Hazardous-area lighting & equipment": "إنارة ومعدات للمناطق الخطرة",
  "PLC and instrumentation packages": "حزم PLC وأجهزة القياس",
  "MCC retrofits": "ترقية لوحات MCC",
  "Containerized RO/UF plants": "محطات RO/UF حاوية",
  "DAF and clarifier systems": "أنظمة DAF والمصفّيات",
  "Dosing and chemical treatment": "أنظمة الجرعات والمعالجة الكيميائية",
  "Wastewater polishing skids": "وحدات تلميع مياه الصرف",
  "Mechanical bulk supply": "توريد ميكانيكي بكميات كبيرة",
  "Electrical & I&C engineering": "هندسة الكهرباء والتحكم",
  "Skid-mounted utility systems": "أنظمة خدمات مركّبة على وحدات",
  "O&M and spare parts": "التشغيل والصيانة وقطع الغيار",
  "Brownfield modifications": "تعديلات على المنشآت القائمة",
  "Production-increase projects": "مشاريع زيادة الإنتاج",
  "Utility upgrades": "ترقية الخدمات",
  "Construction supervision": "إشراف على البناء",

  // ----- Sectors (project experience) -----
  "Multi-sector": "متعدد القطاعات",

  // ----- Page header subtitles / generic -----
  "Representative Project Experience": "نماذج من خبرات المشاريع",
  "Representative categories of engineering, procurement and project development assignments undertaken by Waves Technology. Specific project details, capacities and client names are available on request, subject to confidentiality.":
    "فئات تمثيلية من ارتباطات الهندسة والتوريد وتطوير المشاريع التي نفّذتها ويفز تكنولوجي. تفاصيل المشاريع المحددة والسعات وأسماء العملاء متاحة عند الطلب، مع مراعاة السرية.",
  "Technology Partners & Vendor Network": "شركاء التكنولوجيا وشبكة المورّدين",
  "Waves Technology FZCO works with a curated network of international technology providers, approved manufacturers and strategic suppliers — engaged on a project-by-project basis.":
    "تتعاون ويفز تكنولوجي مع شبكة منتقاة من مزوّدي التكنولوجيا الدوليين والمصنّعين المعتمدين والمورّدين الاستراتيجيين — يتم التعاقد معهم على أساس كل مشروع على حدة.",

  // ----- Service category subtitle bullets (common items) -----
  "Reverse Osmosis (RO) Systems": "أنظمة التناضح العكسي (RO)",
  "Ultrafiltration (UF) Systems": "أنظمة الفلترة الدقيقة (UF)",
  "DAF Systems": "أنظمة DAF",
  "Clarifiers": "المصفّيات",
  "Multimedia Filtration": "الفلترة متعددة الوسائط",
  "Chemical Dosing Systems": "أنظمة الجرعات الكيميائية",
  "Cartridge & Disc Filters": "فلاتر الخرطوش والقرص",
  "Containerized Water Treatment Plants": "محطات معالجة مياه حاوية",
  "Industrial Water Treatment": "معالجة المياه الصناعية",
  "Municipal Water Treatment": "معالجة المياه البلدية",
  "Wastewater Treatment": "معالجة مياه الصرف",
  "Process Engineering": "هندسة العمليات",
  "Process Calculations": "حسابات العمليات",
  "PFD Development": "إعداد مخطط تدفق العمليات (PFD)",
  "P&ID Development": "إعداد مخطط P&ID",
  "Mechanical Engineering": "الهندسة الميكانيكية",
  "Equipment Datasheets": "بيانات المعدات",
  "Hydraulic Calculations": "الحسابات الهيدروليكية",
  "Piping Layouts": "تخطيطات الأنابيب",
  "General Arrangements": "الترتيبات العامة",
  "Instrumentation Engineering": "هندسة أجهزة القياس",
  "Electrical Engineering": "الهندسة الكهربائية",
  "Control System Integration": "تكامل أنظمة التحكم",
  "Vendor Document Review": "مراجعة وثائق المورّدين",
  "FAT / SAT Support": "دعم اختبارات FAT / SAT",
  "International Sourcing": "التوريد الدولي",
  "Vendor Identification": "تحديد المورّدين",
  "Supplier Qualification Support": "دعم تأهيل الموردين",
  "Procurement Coordination": "تنسيق التوريد",
  "Inspection Coordination": "تنسيق التفتيش",
  "Expediting Support": "دعم التعجيل",
  "Logistics Coordination": "تنسيق اللوجستيات",
  "Commercial & Technical Alignment between Client and Supplier": "المواءمة التجارية والفنية بين العميل والمورد",
  "Pumps & Motors": "المضخات والمحرّكات",
  "Manual Valves (Ball, Gate, Globe, Check)": "الصمامات اليدوية (كروية، بوابة، عالمية، عدم رجوع)",
  "Mechanical Seals": "الأختام الميكانيكية",
  "Blowers": "النافخات",
  "Tanks & Vessels": "الخزانات والأوعية",
  "Piping Systems (CS, SS, UPVC, HDPE, GRP)": "أنظمة الأنابيب (CS، SS، UPVC، HDPE، GRP)",
  "Steel Plates · Dish Heads · Fittings · Bolts & Gaskets": "ألواح فولاذية · رؤوس · وصلات · براغي وحشيات",
  "MCC & LV Panels": "لوحات MCC و LV",
  "PLC-Based Control Systems": "أنظمة تحكم تعتمد PLC",
  "SCADA Systems": "أنظمة SCADA",
  "Instrumentation (Flow / Pressure / Level Transmitters)": "أجهزة القياس (مرسلات التدفق / الضغط / المستوى)",
  "Control & On/Off Valves": "صمامات التحكم وعلى/إيقاف",
  "Power Transformers & Diesel Generators": "محوّلات الطاقة والمولدات الديزل",
  "Explosion-Proof Equipment": "المعدات المقاومة للانفجار",
  "Industrial UPS, Batteries & Chargers": "أنظمة UPS الصناعية، البطاريات والشواحن",
  "LED Lighting, Earthing & Cable Trays": "إنارة LED، التأريض وحوامل الكوابل",
  "Concept Development": "تطوير المفهوم",
  "Feasibility Studies": "دراسات الجدوى",
  "Process Optimization": "تحسين العمليات",
  "Technology Selection": "اختيار التكنولوجيا",
  "Vendor Coordination": "تنسيق المورّدين",
  "Budgetary Estimation Support": "دعم التقدير المبدئي للتكاليف",
  "Procurement Planning": "تخطيط التوريد",
  "Engineering Review": "المراجعة الهندسية",
  "Project Execution Support": "دعم تنفيذ المشاريع",
  "Commissioning Planning": "تخطيط التشغيل",
};

export const tr = (lang, en) => (lang === "ar" && AR[en] ? AR[en] : en);
